{
	"backToStartPage": "Retour à la page d’accueil",
	"transactionDetailsTitle": "Détails de la transaction",
	"btnVerifyTransactions": "Vérifier les transactions",
	"kpi": {
		"date": "Date",
		"quantity": "Quantité",
		"carbonReductions": "Réductions de carbone"
	},
	"verifyTransactionModal": {
		"title": "Vérifier la transaction",
		"description": "Veuillez saisir l’ID d’enregistrement pour cette transaction. Vous pouvez trouver cette information sur la déclaration.",
		"recordIdLabel": "ID d’enregistrement",
		"cancelTitle": "Annuler",
		"verifyTitle": "Vérifier",
		"errors": {
			"recordIdRequired": "L’ID d’enregistrement est requis",
			"recordIdInvalid": "Record ID must be 16 characters (letters or numbers), formatted like ABCD 1234 EFGH 5678",
			"verificationFailed": "La transaction n’a pas pu être vérifiée. Veuillez vérifier l’ID d’enregistrement"
		}
	},
	"errors": {
		"notFound": "Transaction introuvable"
	}
}
